import React, { useState } from "react";
import { useTranslation } from "react-i18next";

const DotsLoader = ({ white }) => {
  const { i18n, t } = useTranslation();
  const [language, setLanguage] = useState(i18n.language);

  function changeLanguage(e) {
    i18n.changeLanguage(e.target.value);
    setLanguage(e.target.value);
  }

  return (
    <select
      className="en Opensans"
      style={{ color: white ? "#fff" : "#005494" }}
      value={language}
      onChange={changeLanguage}
    >
      <option style={{ color: "black" }} value="en">
        {t("EN")}{" "}
      </option>
      <option style={{ color: "black" }} value="ch">
        {t("CH")}
      </option>
    </select>
  );
};

export default DotsLoader;
